import { Control, Controller } from 'react-hook-form';
import { maskPhoneNum } from './maskPhoneNum';
import { ErrorText, TextInput } from '@buoyhealth/common.buoy-input';
import FormLabel from '../FormLabel';

export interface IPhoneTextInputProps {
  control: Control<any, any>;
  label?: string;
  required?: boolean;
  errorMessage?: string;
  tooltipText?: string;
}

const PhoneTextInput = ({
  control,
  label,
  tooltipText,
  required,
  errorMessage,
  ...rest
}: IPhoneTextInputProps) => {
  return (
    <Controller
      control={control}
      name="phoneNumber"
      render={({ field, fieldState }) => {
        const { ref: inputRef, ...fieldProps } = field;
        return (
          <div>
            {label && <FormLabel name="phoneNumber" label={label} tooltipText={tooltipText} />}
            <TextInput
              {...fieldProps}
              InputLabelProps={{
                htmlFor: 'phone-number-input',
                className: 'bp-text-base',
              }}
              InputProps={{
                inputProps: {
                  'data-testid': 'phone-number',
                  className: '!bp-placeholder-gray-70',
                },
                sx: { backgroundColor: 'white' },
              }}
              autoComplete="tel-national"
              error={fieldState.invalid}
              id="phone-number-input"
              inputMode="tel"
              inputRef={inputRef}
              placeholder="(XXX) XXX-XXXX"
              type="tel"
              value={maskPhoneNum(field.value)}
              required={required}
              {...rest}
            />
            <ErrorText
              show={!!fieldState.error}
              message={errorMessage || 'Enter a 10-digit phone number'}
            />
          </div>
        );
      }}
      rules={{
        pattern: /^[(][0-9]{3}[)][\s][0-9]{3}[-][0-9]{4}$/,
        required,
      }}
    />
  );
};

export default PhoneTextInput;
